import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-MediumItalicNew.woff2';
import woff from '../src/PPMori-MediumItalicNew.woff';

export const ppMoriMediumItalic: FontFaceSpec = {
  weight: 500,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
